import {Box, Grid} from 'platform/foundation';
import {match} from 'ts-pattern';

import {usePermissions} from '@dms/shared';

import type {CustomerInsightsRecord} from '../../../types/CustomerInsightsViewModel';
import {CustomerInsightsRecordListItem} from './CustomerInsightsRecordListItem';

interface CustomerInsightsRecordListProps {
  records: CustomerInsightsRecord[];
}

export function CustomerInsightsRecordList(props: CustomerInsightsRecordListProps) {
  const [canReadInterestTags, canReadBusinessCaseTags] = usePermissions({
    permissionKeys: ['interestTagRead', 'businessCaseTagRead'],
    scopes: {
      interestTagRead: {
        // Customer Insights is customer-wide and the tag endpoint enforces record ACL.
        participation: 'SKIP',
        // A customer-wide card has no single branch context.
        branchId: 'SKIP',
      },
      businessCaseTagRead: {
        // Customer Insights is customer-wide and the tag endpoint enforces record ACL.
        participation: 'SKIP',
        // A customer-wide card has no single branch context.
        branchId: 'SKIP',
      },
    },
  });

  return (
    <Box role="list">
      <Grid columns={1} spacing={3}>
        {props.records.map((record) => (
          <CustomerInsightsRecordListItem
            key={record.id}
            record={record}
            canReadTags={match(record.kind)
              .with('interest', () => canReadInterestTags === true)
              .with('businessCase', () => canReadBusinessCaseTags === true)
              .otherwise(() => false)}
          />
        ))}
      </Grid>
    </Box>
  );
}
